import { CircularProgress } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import _ from "lodash";
import { useEffect, useState } from "react";
import { subjectApi } from "./subject.queries";

export default function SubjectSelect(props) {
	const useGetAll = subjectApi.useGetAll();
	const subjects = useGetAll.data || [];
	
	const [value, setValue] = useState(props.value);

	useEffect(() => {
		setValue(props.value);
	}, [props.value]);

	const onChange = (e) => {
		const id = e.target.value;
		setValue(id);
		props.onChange(e, _.find(subjects, { id }));
	}

	return (
		<FormControl variant="standard" fullWidth required={props.required}>
			<InputLabel>{useGetAll.isPending ? <CircularProgress size={15} /> : 'Subject'}</InputLabel>
			<Select value={value} label="Subject" onChange={(e) => onChange(e)}>
				{subjects?.length > 0 && _.sortBy(subjects, 'name').map((subject) => (
					<MenuItem value={subject.id} key={subject.id}>{subject.name}</MenuItem>
				))}
			</Select>
		</FormControl>
	);
}
